import type { Person, Zone } from '@dissidium/contracts';

/** Deterministic bench/template identity creation; never used to refresh a survivor. */
export function makePerson(id: string, name: string, location: Zone = 'Z03', runId = 'run:1'): Person {
  return {
    id, lineageKey: id, presentationKey: `presentation:${id}`, kinshipKeys: [], lifecycle: 'active', location,
    current: { name, origin: 'disgraced-legionary', culture: 'Orsene', originalRunId: runId, latestRunId: runId,
      equipment: [], inventory: [], skills: [], abilities: [], preparedRites: [], reagents: [], hp: 8, maxHp: 10,
      allegiances: [], oaths: [], reputation: [], personalOutcome: 'Unresolved', relationships: [], deeds: [], values: ['Keep promises'], memories: [], evidence: [] },
    original: null, deathEventId: null,
  };
}
